import { jsx as t, jsxs as d, Fragment as k } from "react/jsx-runtime";
import { withManagedProps as A } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import { logoBlueprint as ve, menuTriggerBlueprint as ye, cartTriggerBlueprint as Se, accountTriggerBlueprint as pe, template1Styling as R, searchTriggerBlueprint as Ce, template2Styling as x, template3Styling as j, template4Styling as H, bareboneBlueprint as q } from "./index-blueprint.es.js";
import { TRYLogo as Ne, BurgerIcon as Ie, CartIcon as we, UserIcon as ke, MagnifierIcon as xe, CrossIcon as je } from "@made-people/blueprint-icons";
import { useLink as $, useNavigate as Le } from "@made-people/grease-link";
import I from "clsx";
import { buttonContentPropsSchema as Z, Button as U } from "@made-people/blueprint-button";
import { overlayEventEmitter as D } from "@made-people/blueprint-overlay";
import { useMemo as W, useState as L, useEffect as V, useRef as Ae, useCallback as ce } from "react";
import { useCartState as Pe } from "@made-people/grease-cart";
import { motion as se, AnimatePresence as Be } from "motion/react";
import { StickyWrapper as O } from "@made-people/blueprint-sticky-wrapper";
import { searchInputSchema as ge, SearchInput as de } from "@made-people/blueprint-search";
import { siteSettingsTriggerSchema as X, SiteSettingsTrigger as ee } from "@made-people/blueprint-site-settings";
import "@made-people/blueprint";
const P = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  svg: e.custom().optional(),
  className: e.string().optional()
}), Q = y(
  {
    schema: P,
    defaultProps: {
      enabled: !0,
      svg: /* @__PURE__ */ t(Ne, {})
    }
  },
  ({ blueprint: l, variants: c, svg: b, enabled: s, className: r }) => {
    const n = $(), i = (l ?? ve).styles(c);
    return s ? /* @__PURE__ */ t("div", { className: I(i.wrapper, r), children: /* @__PURE__ */ t(n, { className: i.link, href: "", "aria-label": "Go to home", children: b }) }) : null;
  }
), J = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  overlayId: e.string().optional(),
  className: e.string().optional()
}), te = y(
  {
    schema: J,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Menu"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(Ie, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: c, enabled: b, className: s, ...r }) => {
    var i, o, u, g, m, h;
    const a = (l ?? ye).styles(c);
    return b === !1 ? null : /* @__PURE__ */ d(
      "div",
      {
        className: I(a.wrapper, s),
        onClick: () => D.emit("open", {
          overlayId: r.overlayId
        }),
        children: [
          !((i = r.button) != null && i.enabled) && /* @__PURE__ */ d(k, { children: [
            ((o = r.icon) == null ? void 0 : o.enabled) && /* @__PURE__ */ t("span", { className: a.icon, children: r.icon.iconSvg }),
            ((u = r.label) == null ? void 0 : u.enabled) && /* @__PURE__ */ t("span", { className: a.label, children: r.label.labelText })
          ] }),
          ((g = r.button) == null ? void 0 : g.enabled) && /* @__PURE__ */ t(
            U,
            {
              as: "span",
              label: ((m = r.label) == null ? void 0 : m.enabled) && r.label.labelText,
              iconLeft: ((h = r.icon) == null ? void 0 : h.enabled) && r.icon.iconSvg,
              ...r.button.settings
            }
          )
        ]
      }
    );
  }
), B = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  qtyDisplay: e.enum(["total_quantity", "total_items"]).optional(),
  animateQtyOnUpdate: e.boolean().optional(),
  type: e.enum(["mini-cart", "link-to-checkout"]).optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  className: e.string().optional()
}), F = y(
  {
    schema: B,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Cart"
      },
      type: "link-to-checkout",
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(we, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: c, enabled: b, type: s, className: r, ...n }) => {
    var N;
    const i = (l ?? Se).styles(c), { cart: o } = Pe(), u = $(), g = W(() => n.qtyDisplay === "total_items" ? o == null ? void 0 : o.items.length : o == null ? void 0 : o.items.reduce((T, v) => T + v.quantity, 0), [o, n.qtyDisplay]), [m, h] = L(g), [f, p] = L(!1);
    V(() => {
      if (m !== null && g !== m && n.animateQtyOnUpdate) {
        p(!0);
        const T = setTimeout(() => p(!1), 500);
        return h(g), () => clearTimeout(T);
      }
    }, [g]);
    const C = W(
      () => {
        var T, v, S;
        return /* @__PURE__ */ t(
          U,
          {
            as: s === "link-to-checkout" ? "a" : "button",
            link: s === "link-to-checkout" ? { href: "checkout" } : void 0,
            onClick: s === "mini-cart" ? () => D.emit("open", { overlayId: "mini-cart" }) : void 0,
            iconLeft: ((T = n.icon) == null ? void 0 : T.enabled) && n.icon.iconSvg,
            iconRight: /* @__PURE__ */ t(
              re,
              {
                qty: g,
                className: i.counter,
                shouldAnimate: f
              }
            ),
            label: ((v = n.label) == null ? void 0 : v.enabled) && n.label.labelText,
            ...(S = n == null ? void 0 : n.button) == null ? void 0 : S.settings,
            className: r
          }
        );
      },
      [s, n.icon, n.label, i.counter, g, f]
    ), w = W(() => {
      var v, S;
      const T = /* @__PURE__ */ d(k, { children: [
        ((v = n.icon) == null ? void 0 : v.enabled) && /* @__PURE__ */ t("span", { className: i.icon, children: n.icon.iconSvg }),
        ((S = n.label) == null ? void 0 : S.enabled) && /* @__PURE__ */ t("span", { className: i.label, children: n.label.labelText }),
        /* @__PURE__ */ t(
          re,
          {
            qty: g,
            className: i.counter,
            shouldAnimate: f
          }
        )
      ] });
      return s === "link-to-checkout" ? /* @__PURE__ */ t(
        u,
        {
          href: "checkout",
          className: I(i.wrapper, r),
          "aria-label": "Go to checkout",
          children: T
        }
      ) : /* @__PURE__ */ t(
        "button",
        {
          className: I(i.wrapper, r),
          onClick: () => D.emit("open", { overlayId: "mini-cart" }),
          children: T
        }
      );
    }, [s, n.icon, n.label, i, g, f]);
    return b ? (N = n.button) != null && N.enabled ? C : w : null;
  }
), re = ({
  qty: l,
  className: c,
  shouldAnimate: b
}) => /* @__PURE__ */ t(
  se.span,
  {
    className: c,
    animate: b ? { scale: [1, 0.9, 1.2, 0.8, 1] } : { scale: 1 },
    transition: {
      duration: 0.4,
      ease: "easeOut"
      // times: [0, 0.2, 0.6, 0.8, 1], // Custom timing for each keyframe
    },
    children: l
  }
), E = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  onClick: e.custom().optional(),
  icon: e.object({
    enabled: e.boolean().optional(),
    iconSvg: e.custom().optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  className: e.string().optional(),
  href: e.string().optional(),
  action: e.enum(["drawer", "page"]).optional(),
  loggedIn: e.object({
    isLoggedIn: e.boolean().optional(),
    showInitials: e.boolean().optional(),
    label: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional()
  }).optional()
}), G = y(
  {
    schema: E,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "My Account"
      },
      icon: {
        enabled: !0,
        iconSvg: /* @__PURE__ */ t(ke, {})
      },
      button: {
        enabled: !1
      },
      loggedIn: {
        isLoggedIn: !1,
        showInitials: !0
      }
    }
  },
  ({ blueprint: l, variants: c, enabled: b, className: s, href: r, onClick: n, ...a }) => {
    var p, C, w, N, T, v, S, M, ne, ae, le, ie, oe;
    const o = (l ?? pe).styles(c), u = Le();
    if (b === !1 || r === void 0 && a.action !== "drawer")
      return null;
    const g = $(), m = (p = a.loggedIn) != null && p.showInitials ? Ee(a.loggedIn.firstName, a.loggedIn.lastName) : "", h = a.action === "drawer" ? "button" : g, f = () => {
      a.action === "drawer" ? D.emit("open", { overlayId: "login-drawer" }) : u(r ?? "");
    };
    return /* @__PURE__ */ d(k, { children: [
      !((C = a.loggedIn) != null && C.isLoggedIn) && /* @__PURE__ */ d("div", { className: I(o.wrapper, s), children: [
        !((w = a.button) != null && w.enabled) && /* @__PURE__ */ d(
          h,
          {
            href: r ?? "",
            "aria-label": "Go to account",
            onClick: f,
            children: [
              ((N = a.icon) == null ? void 0 : N.enabled) && /* @__PURE__ */ t("span", { className: o.icon, children: a.icon.iconSvg }),
              ((T = a.label) == null ? void 0 : T.enabled) && /* @__PURE__ */ t("span", { className: o.label, children: a.label.labelText })
            ]
          }
        ),
        ((v = a.button) == null ? void 0 : v.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "button",
            onClick: f,
            iconLeft: ((S = a.icon) == null ? void 0 : S.enabled) && a.icon.iconSvg,
            label: ((M = a.label) == null ? void 0 : M.enabled) && a.label.labelText,
            ...a.button.settings
          }
        )
      ] }),
      ((ne = a.loggedIn) == null ? void 0 : ne.isLoggedIn) && /* @__PURE__ */ d("div", { className: I(o.wrapper, s), children: [
        !((ae = a.button) != null && ae.enabled) && /* @__PURE__ */ d(g, { href: r ?? "", children: [
          ((le = a.icon) == null ? void 0 : le.enabled) && /* @__PURE__ */ t("span", { className: o.icon, children: /* @__PURE__ */ t("span", { className: o.loggedInInitials, children: m }) }),
          a.loggedIn.label && /* @__PURE__ */ t("span", { className: o.label, children: a.loggedIn.label })
        ] }),
        ((ie = a.button) == null ? void 0 : ie.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "a",
            link: { href: r },
            iconLeft: ((oe = a.icon) == null ? void 0 : oe.enabled) && /* @__PURE__ */ t("span", { className: o.loggedInInitials, children: m }),
            label: a.loggedIn.label && a.loggedIn.label,
            ...a.button.settings
          }
        )
      ] })
    ] });
  }
);
function Ee(l, c) {
  const b = (l == null ? void 0 : l[0]) ?? "", s = (c == null ? void 0 : c[0]) ?? "";
  return `${b}${s}`.toUpperCase();
}
const Y = e.union([
  e.literal("mobile"),
  e.literal("tablet"),
  e.literal("desktop"),
  e.literal("none"),
  e.array(e.enum(["mobile", "tablet", "desktop"]))
]).optional();
function _(l) {
  const c = {
    "data-screen-mobile": "hidden",
    "data-screen-tablet": "hidden",
    "data-screen-desktop": "hidden"
  };
  return l ? (Array.isArray(l) ? l : [l]).forEach((s) => {
    s === "mobile" ? c["data-screen-mobile"] = "visible" : s === "tablet" ? c["data-screen-tablet"] = "visible" : s === "desktop" && (c["data-screen-desktop"] = "visible");
  }) : (c["data-screen-mobile"] = "visible", c["data-screen-tablet"] = "visible", c["data-screen-desktop"] = "visible"), c;
}
const be = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: J.optional().describe("Configure the Menu Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search
   */
  search: ge.optional().describe("Configure the Search"),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional()
}), Me = A(
  "HeaderTemplate1",
  y(
    be,
    ({
      variants: l,
      cartTrigger: c,
      menuTrigger: b,
      accountTrigger: s,
      menu: r,
      topbar: n,
      ...a
    }) => {
      const i = R.main.styles(l);
      return /* @__PURE__ */ d(
        O,
        {
          className: i.wrapper,
          ..._(a == null ? void 0 : a.visibility),
          children: [
            n && n,
            /* @__PURE__ */ d("div", { className: i.nav, children: [
              /* @__PURE__ */ d("div", { className: i.left, children: [
                /* @__PURE__ */ t(
                  te,
                  {
                    ...b,
                    blueprint: R.menuTrigger
                  }
                ),
                r && r,
                /* @__PURE__ */ t("div", { className: i.search, children: /* @__PURE__ */ t(de, { ...a.search }) })
              ] }),
              /* @__PURE__ */ t("div", { className: i.center, children: /* @__PURE__ */ t(Q, { ...a.logo, blueprint: R.logo }) }),
              /* @__PURE__ */ d("div", { className: i.right, children: [
                /* @__PURE__ */ t(
                  G,
                  {
                    ...s,
                    blueprint: R.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  F,
                  {
                    ...c,
                    blueprint: R.cartTrigger
                  }
                )
              ] })
            ] })
          ]
        }
      );
    }
  )
), z = e.object({
  blueprint: e.custom().optional(),
  variants: e.custom().optional(),
  enabled: e.boolean().optional(),
  /**
   * @property {string} [searchRoute] - An optional string representing the search route.
   */
  searchRoute: e.string().optional(),
  onStateChange: e.custom().optional(),
  icons: e.object({
    default: e.custom().or(e.literal(!1)).optional(),
    close: e.custom().or(e.literal(!1)).optional()
  }).optional(),
  label: e.object({
    enabled: e.boolean().optional(),
    labelText: e.string().optional()
  }).optional(),
  button: e.object({
    enabled: e.boolean().optional(),
    settings: Z.optional()
  }).optional(),
  className: e.string().optional()
}), K = y(
  {
    schema: z,
    defaultProps: {
      enabled: !0,
      label: {
        enabled: !1,
        labelText: "Search"
      },
      icons: {
        default: /* @__PURE__ */ t(xe, {}),
        close: /* @__PURE__ */ t(je, {})
      },
      button: {
        enabled: !1
      }
    }
  },
  ({ blueprint: l, variants: c, enabled: b, className: s, onStateChange: r, ...n }) => {
    var p, C;
    const i = (l ?? Ce).styles(c), o = $(), [u, g] = L(!1), m = u ? (p = n == null ? void 0 : n.icons) == null ? void 0 : p.close : (C = n == null ? void 0 : n.icons) == null ? void 0 : C.default;
    if (b === !1)
      return null;
    const h = () => {
      D.emit("open", { overlayId: "search-sidebar" });
    }, f = () => {
      var w, N, T, v, S, M;
      return /* @__PURE__ */ d(k, { children: [
        !((w = n.button) != null && w.enabled) && /* @__PURE__ */ d(k, { children: [
          ((N = n.icons) == null ? void 0 : N.default) && /* @__PURE__ */ t("span", { className: i.icon, children: m }),
          ((T = n.label) == null ? void 0 : T.enabled) && /* @__PURE__ */ t("span", { className: i.label, children: n.label.labelText })
        ] }),
        ((v = n.button) == null ? void 0 : v.enabled) && /* @__PURE__ */ t(
          U,
          {
            as: "span",
            label: ((S = n.label) == null ? void 0 : S.enabled) && n.label.labelText,
            iconLeft: ((M = n.icons) == null ? void 0 : M.default) && m,
            ...n.button.settings
          }
        )
      ] });
    };
    return /* @__PURE__ */ d(k, { children: [
      n.searchRoute && /* @__PURE__ */ t(
        o,
        {
          href: n.searchRoute,
          className: I(i.wrapper, s),
          children: f()
        }
      ),
      !n.searchRoute && /* @__PURE__ */ t(
        "span",
        {
          className: I(i.wrapper, s),
          onClick: h,
          children: f()
        }
      )
    ] });
  }
), ue = e.object({
  variants: e.custom().optional(),
  logo: P.optional().describe("Configure the Logo"),
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  menuTrigger: J.optional().describe("Configure the Menu Trigger"),
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  siteSettingsTrigger: X.optional(),
  visibility: Y,
  menu: e.custom().optional(),
  topbar: e.custom().optional()
}), Re = A(
  "HeaderTemplate2",
  y(
    {
      schema: ue,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: c,
      menuTrigger: b,
      accountTrigger: s,
      searchTrigger: r,
      siteSettingsTrigger: n,
      menu: a,
      topbar: i,
      ...o
    }) => {
      const u = x.main.styles(l), [g, m] = L(!1), h = Ae(null), f = W(
        () => ({
          // Remove dynamic height calculations - let CSS handle it
          overflow: "hidden"
        }),
        []
      ), p = ce((C) => {
        requestAnimationFrame(() => {
          m(C);
        });
      }, []);
      return /* @__PURE__ */ t(k, { children: /* @__PURE__ */ d(
        O,
        {
          forwardedRef: h,
          className: u.wrapper,
          ..._(o == null ? void 0 : o.visibility),
          style: f,
          children: [
            i && i,
            /* @__PURE__ */ d("div", { className: u.nav, children: [
              /* @__PURE__ */ d("div", { className: u.left, children: [
                /* @__PURE__ */ t(
                  te,
                  {
                    ...b,
                    blueprint: x.menuTrigger
                  }
                ),
                a && a,
                /* @__PURE__ */ t(
                  K,
                  {
                    ...r,
                    blueprint: x.searchTrigger,
                    onStateChange: p
                  }
                )
              ] }),
              /* @__PURE__ */ t("div", { className: u.center, children: /* @__PURE__ */ t(Q, { ...o.logo, blueprint: x.logo }) }),
              /* @__PURE__ */ d("div", { className: u.right, children: [
                /* @__PURE__ */ t(
                  ee,
                  {
                    ...n,
                    className: u.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...s,
                    blueprint: x.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  F,
                  {
                    ...c,
                    blueprint: x.cartTrigger
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ t(Be, { mode: "wait", children: g && /* @__PURE__ */ t(
              se.div,
              {
                className: "w-full z-30 px-component-spacing-sm pb-3",
                initial: { height: 0, opacity: 0 },
                animate: {
                  height: "auto",
                  opacity: 1,
                  transition: {
                    height: { duration: 0.3, ease: [0.19, 1, 0.22, 1] },
                    opacity: { duration: 0.2, delay: 0.1 }
                  }
                },
                exit: {
                  height: 0,
                  opacity: 0,
                  transition: {
                    height: { duration: 0.2, ease: "easeOut" },
                    opacity: { duration: 0.15 }
                  }
                },
                style: { overflow: "hidden" },
                children: /* @__PURE__ */ t(
                  de,
                  {
                    autoComplete: { enabled: !0 },
                    autoFocus: !0
                  }
                )
              }
            ) })
          ]
        }
      ) });
    }
  )
), me = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Menu Trigger
   */
  menuTrigger: J.optional().describe("Configure the Menu Trigger"),
  /**
   * Configure the Menu Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional()
}), He = A(
  "HeaderTemplate3",
  y(
    me,
    ({
      variants: l,
      cartTrigger: c,
      menuTrigger: b,
      accountTrigger: s,
      searchTrigger: r,
      menu: n,
      topbar: a,
      ...i
    }) => {
      const o = j.main.styles(l);
      return /* @__PURE__ */ d(
        O,
        {
          className: o.wrapper,
          ..._(i == null ? void 0 : i.visibility),
          children: [
            a && a,
            /* @__PURE__ */ d("div", { className: o.nav, children: [
              /* @__PURE__ */ t("div", { className: o.left, children: /* @__PURE__ */ t(Q, { ...i.logo, blueprint: j.logo }) }),
              /* @__PURE__ */ d("div", { className: o.right, children: [
                /* @__PURE__ */ t(
                  K,
                  {
                    ...r,
                    blueprint: j.searchTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...s,
                    blueprint: j.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  F,
                  {
                    ...c,
                    blueprint: j.cartTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  te,
                  {
                    ...b,
                    blueprint: j.menuTrigger
                  }
                ),
                n && n
              ] })
            ] })
          ]
        }
      );
    }
  )
), he = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Country Selector
   */
  siteSettingsTrigger: X.optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  overlay: e.boolean().optional()
}), qe = A(
  "HeaderTemplate4",
  y(
    {
      schema: he,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: c,
      searchTrigger: b,
      accountTrigger: s,
      siteSettingsTrigger: r,
      menu: n,
      topbar: a,
      overlay: i,
      ...o
    }) => {
      const [u, g] = L(!1), m = ce(() => {
        g(window.scrollY > 100);
      }, []);
      V(() => (window.addEventListener("scroll", m), () => {
        window.removeEventListener("scroll", m);
      }), []);
      const h = H.main.styles(l);
      return /* @__PURE__ */ d(
        O,
        {
          className: h.wrapper,
          overlay: i,
          ..._(o == null ? void 0 : o.visibility),
          "data-scrolled": u,
          children: [
            a && a,
            /* @__PURE__ */ d("div", { className: h.nav, children: [
              /* @__PURE__ */ d("div", { className: h.left, children: [
                /* @__PURE__ */ t(Q, { ...o.logo, blueprint: H.logo }),
                n && n
              ] }),
              /* @__PURE__ */ d("div", { className: h.right, children: [
                /* @__PURE__ */ t(
                  ee,
                  {
                    ...r,
                    className: h.siteSettingsTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  K,
                  {
                    ...b,
                    blueprint: H.searchTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    ...s,
                    blueprint: H.accountTrigger
                  }
                ),
                /* @__PURE__ */ t(
                  F,
                  {
                    ...c,
                    blueprint: H.cartTrigger
                  }
                )
              ] })
            ] })
          ]
        }
      );
    }
  )
), fe = e.object({
  variants: e.custom().optional(),
  /**
   * Configure the Logo
   */
  logo: P.optional().describe("Configure the Logo"),
  /**
   * Configure the Cart Trigger
   */
  cartTrigger: B.optional().describe("Configure the Cart Trigger"),
  /**
   * Configure the Search Trigger
   */
  searchTrigger: z.optional().describe("Configure the Search Trigger"),
  /**
   * Add a separat menu component
   */
  menu: e.custom().optional(),
  /**
   * Configure the Account Trigger
   */
  accountTrigger: E.optional().describe("Configure the Account Trigger"),
  /**
   * Add a separat topbar component
   */
  topbar: e.custom().optional(),
  /**
   * Define visibility per breakpoint
   */
  visibility: Y,
  siteSettingsTrigger: X.optional(),
  search: ge.optional().describe("Configure the Search"),
  overlay: e.boolean().optional()
}), Ue = A(
  "HeaderBarebone",
  y(
    {
      schema: fe,
      defaultProps: {
        siteSettingsTrigger: {
          isEnabled: !1
        }
      }
    },
    ({
      variants: l,
      cartTrigger: c,
      searchTrigger: b,
      accountTrigger: s,
      siteSettingsTrigger: r,
      menu: n,
      topbar: a,
      search: i,
      overlay: o,
      ...u
    }) => {
      const g = q.main.styles(l), [m, h] = L(!1);
      return V(() => {
        const f = () => {
          h(window.scrollY > 100);
        };
        return window.addEventListener("scroll", f), () => {
          window.removeEventListener("scroll", f);
        };
      }, []), /* @__PURE__ */ d(
        O,
        {
          className: g.wrapper,
          overlay: o,
          ..._(u == null ? void 0 : u.visibility),
          "data-scrolled": m,
          children: [
            a && a,
            /* @__PURE__ */ d("div", { className: g.nav, children: [
              /* @__PURE__ */ t(
                Q,
                {
                  ...u.logo,
                  blueprint: q.logo,
                  className: g.logoPosition
                }
              ),
              n && /* @__PURE__ */ t("div", { className: g.menuPosition, children: n }),
              /* @__PURE__ */ t(
                ee,
                {
                  ...r,
                  className: g.siteSettingsTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                K,
                {
                  ...b,
                  blueprint: q.searchTrigger,
                  className: g.searchTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                G,
                {
                  ...s,
                  blueprint: q.accountTrigger,
                  className: g.accountTriggerPosition
                }
              ),
              /* @__PURE__ */ t(
                F,
                {
                  ...c,
                  blueprint: q.cartTrigger,
                  className: g.cartTriggerPosition
                }
              )
            ] })
          ]
        }
      );
    }
  )
), Te = e.discriminatedUnion("template", [
  be.extend({
    template: e.literal("template1")
  }),
  ue.extend({
    template: e.literal("template2")
  }),
  me.extend({
    template: e.literal("template3")
  }),
  he.extend({
    template: e.literal("template4")
  }),
  fe.extend({
    template: e.literal("barebone")
  })
]), De = y(Te, (l) => {
  switch (l.template) {
    case "template1":
      return /* @__PURE__ */ t(Me, { ...l });
    case "template2":
      return /* @__PURE__ */ t(Re, { ...l });
    case "template3":
      return /* @__PURE__ */ t(He, { ...l });
    case "template4":
      return /* @__PURE__ */ t(qe, { ...l });
    case "barebone":
      return /* @__PURE__ */ t(Ue, { ...l });
    default:
      return null;
  }
}), Oe = "template2", Qe = e.object({
  settings: Te.optional()
}), it = A(
  "Header",
  y({ schema: Qe, defaultProps: {} }, (l) => {
    const c = l.settings || { template: Oe };
    return /* @__PURE__ */ t(De, { ...c });
  })
);
export {
  G as AccountTrigger,
  F as CartTrigger,
  it as Header,
  Ue as HeaderBarebone,
  Q as Logo,
  te as MenuTrigger,
  K as SearchTrigger,
  De as SelectTemplate,
  Me as Template1,
  Re as Template2,
  He as Template3,
  qe as Template4,
  E as accountTriggerSchema,
  fe as bareboneSchema,
  Y as breakpointsSchema,
  B as cartTriggerSchema,
  Qe as headerPropsSchema,
  Te as headerSchema,
  P as logoSchema,
  J as menuTriggerSchema,
  z as searchTriggerSchema,
  _ as setBreakpointDataAttributes,
  be as template1Schema,
  ue as template2Schema,
  me as template3Schema,
  he as template4Schema
};
//# sourceMappingURL=index.es.js.map
